const header = {
  headerText: {
    greetings: 'Hello',
    intro: "I'm",
    preTitle: 'a',
  },
};

export default header;
